module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/taxi-stand-icon-e31580670e2b94e31f145296be5a34c2.png";